import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
  List,
  ListItem,
  IconButton,
  Tooltip,
  Avatar,
} from "@mui/material";
import {
  useGetEmployeeScheduleDetailsByMonthforEmpQuery,
  useGetPositionQuery,
  useGetTeamQuery,
  useGetRescheduleOrderByDateQuery,
  useGetMonthActiveRequestQuery,
  useGetEmployeeScheduleDetailsByDateOnlyQuery,
} from "../../../Api/attoDeskApi";
import {
  IActiveRequestList,
  IPosition,
  IScheduleListDetails,
  ITeam,
  ScheduleEdit,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import useUser from "../../../Core/hook/useUser";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Link } from "react-router-dom";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { DateSelectArg, EventClickArg } from "@fullcalendar/core";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import RequestPopUp from "./reschedukle";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import RequestEditPopUp from "./editreschedule";
import EditIcon from "@mui/icons-material/Edit";
import { CiEdit } from "react-icons/ci";
import { FaRegFilePdf } from "react-icons/fa6";
import { AiOutlineFileExcel } from "react-icons/ai";
import GroupIcon from "@mui/icons-material/Group";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

interface ITeampopup {
  staffId: string;
  staffNameFull: String;
}

const Index = ({ staffId, staffNameFull }: ITeampopup) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const { userHasRight } = useUser();
  const [openDrawerPopUP, setOpenDrawerPopUP] = useState(false);
  const [selectedDateDrawerPopUP, setSelectedDateDrawerPopUP] =
    React.useState<Dayjs | null>(dayjs());

  const [selectedDateRequestPopUP, setSelectedDateRequesPopUP] =
    React.useState<Dayjs | null>(dayjs());

  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [selectedCoursing, setSelectedCoursing] =
    useState<IScheduleListDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogRequest, setOpenDialogRequest] = useState(false);

  const [openDialogEditRequest, setOpenDialogEditRequest] = useState(false);
  const [selectedDateEditRequestPopUP, setSelectedDateEditRequesPopUP] =
    React.useState<Dayjs | null>(dayjs());

  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());

  const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("month"));

  const [pdfDate, setPdfDate] = useState<Dayjs | null>(null);
  const [exportType, setExportType] = useState<"excel" | "pdf" | null>(null);

  const { data, isLoading, isError, refetch } =
    useGetEmployeeScheduleDetailsByMonthforEmpQuery({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      empid: String(staffId),
    });

  const {
    data: activeRequestData,
    isLoading: activeRequestIsloading,
    isError: activeRequestIsError,
    refetch: activeRequestRefetch,
  } = useGetMonthActiveRequestQuery({
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
  });

  // const {
  //   data: pdfData,
  //   isLoading: pdfIsLoading,
  //   refetch: padRefetch,
  // } = useGetEmployeeScheduleDetailsByDateOnlyQuery(
  //   pdfDate ? { date: pdfDate.format("YYYY-MM-DD") } : ""
  // );

  const {
    data: pdfData,
    isLoading: pdfIsLoading,
    isError: pdfIsError,
    refetch: padRefetch,
  } = useGetEmployeeScheduleDetailsByDateOnlyQuery(
    { date: pdfDate?.format("YYYY-MM-DD") ?? "" }
    // {
    //   skip: !pdfDate,
    // }
  );

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: OrderData,
    isLoading: OrderDataIsLoadig,
    isError: OrderDataIsError,
  } = useGetRescheduleOrderByDateQuery({
    searchText: "",
    startDate: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const handleCloseDrawerPopUp = () => {
    setOpenDrawerPopUP(false);
    setSelectedDateDrawerPopUP(null);
  };

  const handleCloseDialogRequest = () => {
    setSelectedDateRequesPopUP(null);
    setOpenDialogRequest(false);
    refetch();
    activeRequestRefetch();
  };

  const handleOpenDialogRequest = (date: Dayjs) => {
    setOpenDialogRequest(true);
    setSelectedDateRequesPopUP(date);
  };

  const handleOpenDialogEditRequest = (
    date: Dayjs,
    coursing: IScheduleListDetails
  ) => {
    setOpenDialogEditRequest(true);
    setSelectedDateEditRequesPopUP(date);
    setSelectedCoursing(coursing);
    refetch();
    activeRequestRefetch();
  };

  const handleCloseDialoEditRequest = () => {
    setSelectedCoursing(null);
    setSelectedDateEditRequesPopUP(null);
    setOpenDialogEditRequest(false);
    refetch();
    activeRequestRefetch();
  };
  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const pdfDataList: IScheduleListDetails[] = Array.isArray(pdfData?.data)
    ? (pdfData?.data as IScheduleListDetails[])
    : [];

  const activeRequestList: IActiveRequestList[] = Array.isArray(
    activeRequestData?.data
  )
    ? (activeRequestData?.data as IActiveRequestList[])
    : [];

  const getScheduleIdByDate = (dateStr: string) => {
    const record = activeRequestList.find(
      (d: any) => d.date === dateStr && d.isScheday === true
    );
    return record?.id;
  };

  const handleExportToExcel = (
    list: IScheduleListDetails[],
    exportDate: Dayjs
  ) => {
    const exportData = list.map((row, index) => ({
      "#": index + 1,
      "Employee Name": teamMap.get(row.empid)?.name || "",
      Position: teamMap.get(row.empid)?.positionName || "",
      "Schedule ": `${formatTime(row.schedule?.startTime)} - ${formatTime(
        row.schedule?.endTime
      )}${row.schedule?.spansNextDay == true ? " [next day]" : ""} ${
        row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""
      }`,

      Status: row.isReSchedules ? "Modified" : "Usual",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ScheduleList");
    const paymentMonthYearPrint = dayjs(exportDate).format("YYYY MMM, DD");
    const fileName = `ScheduleList_${paymentMonthYearPrint}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const loadImageSafely = (url?: string): Promise<string | null> => {
    return new Promise((resolve) => {
      if (!url) return resolve(null);

      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = url;

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0);

          const base64 = canvas.toDataURL("image/png");
          resolve(base64);
        } catch {
          resolve(null);
        }
      };

      img.onerror = () => resolve(null);
    });
  };

  const handleExportToPDF = (
    list: IScheduleListDetails[],
    exportDate: Dayjs
  ) => {
    const tableData = list.map((row, index) => [
      index + 1,
      teamMap.get(row.empid)?.name || "",
      teamMap.get(row.empid)?.positionName || "",
      formatTime(row.schedule?.startTime) +
        " - " +
        formatTime(row.schedule?.endTime) +
        (row.schedule?.spansNextDay ? " [next day]" : "") +
        (row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? " [D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? " [Up]"
            : ""
          : ""),
      row.isReSchedules ? "Modified" : "Usual",
    ]);

    const tableHeaders = [
      ["#", "Employee Name", "Position", "Schedule ", "Status"],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const paymentMonthYearPrint = dayjs(exportDate).format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Schedule List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Date: ${paymentMonthYearPrint}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `ScheduleList_${paymentMonthYearPrint}.pdf`;

      doc.save(fileName);
    };
  };

  const handleAddProductClick = () => {
    // navigate("/re-Schedule/create");
    navigate(
      `/re-Schedule/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };

  const handleAddweeklyReport = () => {
    navigate(`/attendance/weekly/report`);
  };

  const handleExportByDate = (date: Dayjs, type: "pdf" | "excel") => {
    const selectedDate = dayjs(date).format("YYYY-MM-DD");

    const filteredList = coursings.filter(
      (row) => dayjs(row.date).format("YYYY-MM-DD") === selectedDate
    );

    if (!filteredList.length) {
      alert("No schedules for this date");
      return;
    }

    if (type === "pdf") {
      handleExportToPDF(filteredList, date);
    } else {
      handleExportToExcel(filteredList, date);
    }
  };

  if (
    isLoading ||
    tenantIsLoading ||
    positionLoading ||
    OrderDataIsLoadig ||
    activeRequestIsloading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card
            className={classes.card}
            sx={{
              minHeight: "100vh",
            }}
          >
            <Grid container spacing={2} pt={2}>
              {isMobileRes ? (
                <Box
                  sx={{
                    height: "100hv",
                    overflowY: "auto",
                    overflowX: "auto",
                    padding: "2px",

                    "&::-webkit-scrollbar": {
                      width: "6px",
                      height: "6px",
                    },

                    "&::-webkit-scrollbar-track": {
                      background: "#eeeeee",
                    },

                    "&::-webkit-scrollbar-thumb": {
                      background: "#cccccc",
                      borderRadius: "10px",
                    },

                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#bdbdbd",
                    },
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    m={2}
                    pt={4}
                    sx={{
                      minHeight: isMobileRes ? "100vh" : "100vh",
                      minWidth: isMobileRes ? "150vh" : "100%",
                      overflowX: "auto",
                    }}
                  >
                    <div
                    // style={{
                    //   maxWidth: "100%",
                    //   minWidth: "100vh",
                    // }}
                    >
                      <FullCalendar
                        plugins={[
                          dayGridPlugin,
                          timeGridPlugin,
                          interactionPlugin,
                        ]}
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,timeGridWeek,timeGridDay",
                        }}
                        initialView="dayGridMonth"
                        editable={true}
                        selectable={true}
                        selectMirror={true}
                        dayMaxEvents={true}
                        events={coursings.map((row, index) => {
                          const startTime = row.schedule?.startTime;
                          const endTime = row.schedule?.endTime;
                          const date = row.date;
                          const schedulTimeSlot = `${formatTime(
                            startTime
                          )} - ${formatTime(endTime)}`;
                          let title = formatTime(endTime); // Show end time first in title
                          let subtitle = `${formatTime(
                            startTime
                          )} - ${formatTime(endTime)}`; // Show time range in subtitle

                          if (row.schedule?.spansNextDay) {
                            title += " [next day]";
                            subtitle += " [next day]";
                          }

                          if (row.schedule?.schedule_end_date) {
                            if (row.schedule.status === "deleted") {
                              title += " [D]";
                              subtitle += " [D]";
                            } else if (row.schedule.status === "updated") {
                              title += " [Up]";
                              subtitle += " [Up]";
                            }
                          }

                          // if (row.empid) {
                          //   const empName = teamMap.get(row.empid)?.name || "";
                          //   title += ` ${empName}`;
                          //   subtitle += ` ${empName}`;
                          // }

                          return {
                            id: String(index),
                            title,
                            start: `${dayjs(date).format(
                              "YYYY-MM-DD"
                            )}T${startTime}`,
                            end: `${dayjs(date).format(
                              "YYYY-MM-DD"
                            )}T${endTime}`,
                            // backgroundColor:
                            //   row.schedule?.status === "deleted"
                            //     ? "#f8d7da"
                            //     : row.schedule?.status === "updated"
                            //     ? "#fff3cd"
                            //     : "#d1ecf1",
                            // borderColor:
                            //   row.schedule?.status === "deleted"
                            //     ? "#f5c6cb"
                            //     : row.schedule?.status === "updated"
                            //     ? "#ffeeba"
                            //     : "#bee5eb",
                            // textColor:
                            //   row.schedule?.status === "deleted"
                            //     ? "#721c24"
                            //     : row.schedule?.status === "updated"
                            //     ? "#856404"
                            //     : "#0c5460",
                            backgroundColor:
                              row.schedule?.status === "deleted"
                                ? "#f8d7da"
                                : row.isReSchedules
                                ? "#fff3cd"
                                : "#d1ecf1",

                            borderColor:
                              row.schedule?.status === "deleted"
                                ? "#f5c6cb"
                                : row.isReSchedules
                                ? "#ffeeba"
                                : "#bee5eb",

                            textColor:
                              row.schedule?.status === "deleted"
                                ? "#721c24"
                                : row.isReSchedules
                                ? "#856404"
                                : "#0c5460",

                            display: "block",
                            extendedProps: {
                              empid: row.empid,
                              subtitle: subtitle,
                              isReSchedules: row.isReSchedules,
                              scheduleStatus: row.schedule?.status,
                              spansNextDay: row.schedule?.spansNextDay,
                              meeting_time: row.schedule?.startTime || "",
                              meeting_Date: row.date || "",
                              schedule_end_date:
                                row.schedule?.schedule_end_date || "",
                              schedulTimeSlot: schedulTimeSlot || "",
                              row,
                            },
                          };
                        })}
                        eventContent={(eventInfo) => {
                          const {
                            empid,
                            isReSchedules,
                            scheduleStatus,
                            spansNextDay,
                            meeting_time,
                            meeting_Date,
                            subtitle,
                            schedule_end_date,
                            schedulTimeSlot,
                            row,
                          } = eventInfo.event.extendedProps;

                          const displayTitle =
                            eventInfo.event.title.length > 20
                              ? eventInfo.event.title.slice(0, 20) + "..."
                              : eventInfo.event.title;

                          const today = dayjs().startOf("day");
                          const eventStart = eventInfo.event.start;

                          const isPastDate = eventStart
                            ? dayjs(eventStart).isBefore(today)
                            : false;

                          const customer = teamMap.get(row.empid);

                          return (
                            <Tooltip
                              placement="bottom-end"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor:
                                      theme.palette.cardAdd.bgColor,
                                    color: theme.palette.heading.headingColor,
                                    borderRadius: setCardBRadius,
                                    padding: 1.5,
                                    border: `0.2px solid ${theme.palette.primary.main}`,
                                    // boxShadow: `0 0 10px ${theme.palette.primary.main}`, // ✅ only one boxShadow
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: theme.palette.cardAdd.borderColor,
                                  },
                                },
                              }}
                              title={
                                <Grid container spacing={1}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      fontWeight="bold"
                                      fontSize={14}
                                      sx={{
                                        color: theme.palette.primary.main,
                                      }}
                                    >
                                      {subtitle || displayTitle}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    ml={3}
                                  >
                                    {meeting_Date && (
                                      <Typography fontSize={13}>
                                        <strong>Date:</strong>{" "}
                                        {dayjs(meeting_Date).format(
                                          "MMM DD, YYYY"
                                        )}
                                      </Typography>
                                    )}
                                    {schedulTimeSlot && (
                                      <Typography fontSize={13}>
                                        <strong>Time:</strong> {schedulTimeSlot}
                                      </Typography>
                                    )}
                                    {empid && (
                                      <Typography fontSize={13}>
                                        <strong>Staff:</strong>{" "}
                                        {teamMap.get(empid)?.name || ""}
                                      </Typography>
                                    )}
                                    {isReSchedules === true && (
                                      <Typography
                                        textAlign="right"
                                        sx={{
                                          color: "#1976d2",
                                          fontWeight: 600,
                                          lineHeight: 1.5,
                                          fontSize: "0.875rem",
                                          paddingLeft: "1px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        -- Reschedule
                                      </Typography>
                                    )}
                                    {schedule_end_date &&
                                      (scheduleStatus === "deleted" ||
                                        scheduleStatus === "updated") && (
                                        <Typography
                                          textAlign="right"
                                          sx={{
                                            color:
                                              scheduleStatus === "deleted"
                                                ? "#d32f2f"
                                                : scheduleStatus === "updated"
                                                ? "#1976d2"
                                                : "#000",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            paddingLeft: "1px",
                                            fontStyle: "italic",
                                          }}
                                        >
                                          {schedule_end_date && (
                                            <>
                                              -- Previous time slot{" "}
                                              {scheduleStatus === "deleted"
                                                ? "(deleted on "
                                                : scheduleStatus === "updated"
                                                ? "(updated on "
                                                : "("}
                                              {dayjs(schedule_end_date).format(
                                                "MMM D, YYYY h:mm A"
                                              )}
                                              {")"} --
                                            </>
                                          )}
                                        </Typography>
                                      )}
                                  </Grid>
                                </Grid>
                              }
                            >
                              <div
                                style={{
                                  marginBottom: "6px",
                                  borderRadius: "4px",
                                  padding: "4px 6px",
                                  backgroundColor: eventInfo.backgroundColor,
                                  color: eventInfo.textColor,
                                  display: "flex",
                                  alignItems: "center",
                                  overflow: "hidden",
                                  cursor: isPastDate ? "none" : "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    minWidth: 0,
                                    marginLeft: 6,
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {(meeting_time || displayTitle) && (
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {meeting_time
                                        ? `${formatTime(
                                            meeting_time
                                          )} - ${displayTitle}`
                                        : displayTitle}
                                    </span>
                                  )}
                                </div>

                                {!isPastDate && (
                                  <div
                                    style={{
                                      flexShrink: 0,
                                      width: 20,
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <CiEdit
                                      style={{ fontSize: 14, opacity: 0.9 }}
                                    />
                                  </div>
                                )}
                              </div>
                            </Tooltip>
                          );
                        }}
                        dateClick={(info: DateClickArg) => {
                          const clickedDate = dayjs(info.dateStr);
                          // handleOpenDrawerPopUp(clickedDate);
                        }}
                        eventClick={(info: EventClickArg) => {
                          const event = info.event;
                          const clickedDateOnclick = dayjs(event.start);
                          const today = dayjs();

                          if (clickedDateOnclick.isBefore(today, "day")) {
                            return;
                          }
                          const row = info.event.extendedProps.row;
                          handleOpenDialogEditRequest(clickedDateOnclick, row);
                        }}
                        datesSet={(dateInfo) => {
                          const start = dayjs(dateInfo.start).format(
                            "YYYY-MM-DD"
                          );
                          const end = dayjs(dateInfo.end).format("YYYY-MM-DD");

                          console.log(
                            "Month changed, fetching data from",
                            start,
                            "to",
                            end
                          );
                          setStartDate(dayjs(start));
                          setEndDate(dayjs(end));
                        }}
                        dayCellDidMount={(arg) => {
                          arg.el.style.cursor = "pointer";

                          const cellDate = dayjs(arg.date).format("YYYY-MM-DD");
                        }}
                        dayCellContent={(arg) => {
                          const cellDate = dayjs(arg.date);
                          const formattedDate = cellDate.format("YYYY-MM-DD");
                          const today = dayjs().startOf("day");
                          const isPastDate = cellDate.isBefore(today, "day");
                          const activeId = getScheduleIdByDate(formattedDate);

                          const ActionCard = ({
                            label,
                            icon,
                            bg,
                            color,
                            onClick,
                          }: {
                            label: string;
                            icon: React.ReactNode;
                            bg: string;
                            color: string;
                            onClick: () => void;
                          }) => (
                            <Tooltip
                              placement="bottom-end"
                              title={label}
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor:
                                      theme.palette.cardAdd.bgColor,
                                    color: theme.palette.heading.headingColor,
                                    borderRadius: setCardBRadius,
                                    padding: 1.5,
                                    border: `0.2px solid ${theme.palette.primary.main}`,
                                    fontSize: 13,
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: theme.palette.cardAdd.borderColor,
                                  },
                                },
                              }}
                              arrow
                            >
                              <span>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isPastDate) onClick();
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    background: bg,
                                    color,
                                    border: "none",
                                    padding: "4px 10px",
                                    borderRadius: "4px",
                                    transition: "all 0.2s ease",
                                    minHeight: "20px",
                                  }}
                                >
                                  {icon}
                                  {/* <span>{label}</span> */}
                                </div>
                              </span>
                            </Tooltip>
                          );
                          return (
                            <div style={{ width: "100%", padding: "4px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  flexWrap: "wrap",
                                }}
                              >
                                {!isPastDate && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleOpenDialogRequest(cellDate);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      color: "#1976d2",
                                      background: "#dbe8f4",
                                      border: "none",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      transition: "all 0.2s ease",
                                    }}
                                  >
                                    + Add
                                  </button>
                                )}

                                {/* Date */}
                                <div
                                  style={{
                                    fontWeight: 700,
                                    fontSize: "13px",
                                    marginLeft: "auto",
                                  }}
                                >
                                  {cellDate.date()}
                                </div>
                              </div>
                            </div>
                          );
                        }}
                      />
                    </div>
                  </Grid>
                </Box>
              ) : (
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  m={2}
                  pt={4}
                  sx={{
                    minHeight: "100vh",
                  }}
                >
                  <div
                  // style={{
                  //   maxWidth: "100%",
                  //   minWidth: "100vh",
                  // }}
                  >
                    <FullCalendar
                      plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                      ]}
                      headerToolbar={{
                        left: "prev,next today",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay",
                      }}
                      initialView="dayGridMonth"
                      editable={true}
                      selectable={true}
                      selectMirror={true}
                      dayMaxEvents={true}
                      events={coursings.map((row, index) => {
                        const startTime = row.schedule?.startTime;
                        const endTime = row.schedule?.endTime;
                        const date = row.date;
                        const schedulTimeSlot = `${formatTime(
                          startTime
                        )} - ${formatTime(endTime)}`;
                        let title = formatTime(endTime); // Show end time first in title
                        let subtitle = `${formatTime(startTime)} - ${formatTime(
                          endTime
                        )}`; // Show time range in subtitle

                        if (row.schedule?.spansNextDay) {
                          title += " [next day]";
                          subtitle += " [next day]";
                        }

                        if (row.schedule?.schedule_end_date) {
                          if (row.schedule.status === "deleted") {
                            title += " [D]";
                            subtitle += " [D]";
                          } else if (row.schedule.status === "updated") {
                            title += " [Up]";
                            subtitle += " [Up]";
                          }
                        }

                        // if (row.empid) {
                        //   const empName = teamMap.get(row.empid)?.name || "";
                        //   title += ` ${empName}`;
                        //   subtitle += ` ${empName}`;
                        // }

                        return {
                          id: String(index),
                          title,
                          start: `${dayjs(date).format(
                            "YYYY-MM-DD"
                          )}T${startTime}`,
                          end: `${dayjs(date).format("YYYY-MM-DD")}T${endTime}`,
                          // backgroundColor:
                          //   row.schedule?.status === "deleted"
                          //     ? "#f8d7da"
                          //     : row.schedule?.status === "updated"
                          //     ? "#fff3cd"
                          //     : "#d1ecf1",
                          // borderColor:
                          //   row.schedule?.status === "deleted"
                          //     ? "#f5c6cb"
                          //     : row.schedule?.status === "updated"
                          //     ? "#ffeeba"
                          //     : "#bee5eb",
                          // textColor:
                          //   row.schedule?.status === "deleted"
                          //     ? "#721c24"
                          //     : row.schedule?.status === "updated"
                          //     ? "#856404"
                          //     : "#0c5460",
                          backgroundColor:
                            row.schedule?.status === "deleted"
                              ? "#f8d7da"
                              : row.isReSchedules
                              ? "#fff3cd"
                              : "#d1ecf1",

                          borderColor:
                            row.schedule?.status === "deleted"
                              ? "#f5c6cb"
                              : row.isReSchedules
                              ? "#ffeeba"
                              : "#bee5eb",

                          textColor:
                            row.schedule?.status === "deleted"
                              ? "#721c24"
                              : row.isReSchedules
                              ? "#856404"
                              : "#0c5460",

                          display: "block",
                          extendedProps: {
                            empid: row.empid,
                            subtitle: subtitle,
                            isReSchedules: row.isReSchedules,
                            scheduleStatus: row.schedule?.status,
                            spansNextDay: row.schedule?.spansNextDay,
                            meeting_time: row.schedule?.startTime || "",
                            meeting_Date: row.date || "",
                            schedule_end_date:
                              row.schedule?.schedule_end_date || "",
                            schedulTimeSlot: schedulTimeSlot || "",
                            row,
                          },
                        };
                      })}
                      eventContent={(eventInfo) => {
                        const {
                          empid,
                          isReSchedules,
                          scheduleStatus,
                          spansNextDay,
                          meeting_time,
                          meeting_Date,
                          subtitle,
                          schedule_end_date,
                          schedulTimeSlot,
                          row,
                        } = eventInfo.event.extendedProps;

                        const displayTitle =
                          eventInfo.event.title.length > 20
                            ? eventInfo.event.title.slice(0, 20) + "..."
                            : eventInfo.event.title;

                        const today = dayjs().startOf("day");
                        const eventStart = eventInfo.event.start;

                        const isPastDate = eventStart
                          ? dayjs(eventStart).isBefore(today)
                          : false;

                        const customer = teamMap.get(row.empid);

                        return (
                          <Tooltip
                            placement="bottom-end"
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor:
                                    theme.palette.cardAdd.bgColor,
                                  color: theme.palette.heading.headingColor,
                                  borderRadius: setCardBRadius,
                                  padding: 1.5,
                                  border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                  // boxShadow: `0 0 10px ${theme.palette.primary.main}`, // ✅ only one boxShadow
                                },
                              },
                              arrow: {
                                sx: {
                                  color: theme.palette.cardAdd.borderColor,
                                },
                              },
                            }}
                            title={
                              <Grid container spacing={1}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography
                                    fontWeight="bold"
                                    fontSize={14}
                                    sx={{
                                      color: theme.palette.primary.main,
                                    }}
                                  >
                                    {subtitle || displayTitle}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  ml={3}
                                >
                                  {meeting_Date && (
                                    <Typography fontSize={13}>
                                      <strong>Date:</strong>{" "}
                                      {dayjs(meeting_Date).format(
                                        "MMM DD, YYYY"
                                      )}
                                    </Typography>
                                  )}
                                  {schedulTimeSlot && (
                                    <Typography fontSize={13}>
                                      <strong>Time:</strong> {schedulTimeSlot}
                                    </Typography>
                                  )}
                                  {empid && (
                                    <Typography fontSize={13}>
                                      <strong>Staff:</strong>{" "}
                                      {teamMap.get(empid)?.name || ""}
                                    </Typography>
                                  )}
                                  {isReSchedules === true && (
                                    <Typography
                                      textAlign="right"
                                      sx={{
                                        color: "#1976d2",
                                        fontWeight: 600,
                                        lineHeight: 1.5,
                                        fontSize: "0.875rem",
                                        paddingLeft: "1px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      -- Reschedule
                                    </Typography>
                                  )}
                                  {schedule_end_date &&
                                    (scheduleStatus === "deleted" ||
                                      scheduleStatus === "updated") && (
                                      <Typography
                                        textAlign="right"
                                        sx={{
                                          color:
                                            scheduleStatus === "deleted"
                                              ? "#d32f2f"
                                              : scheduleStatus === "updated"
                                              ? "#1976d2"
                                              : "#000",
                                          fontWeight: 600,
                                          lineHeight: 1.5,
                                          fontSize: "0.875rem",
                                          paddingLeft: "1px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        {schedule_end_date && (
                                          <>
                                            -- Previous time slot{" "}
                                            {scheduleStatus === "deleted"
                                              ? "(deleted on "
                                              : scheduleStatus === "updated"
                                              ? "(updated on "
                                              : "("}
                                            {dayjs(schedule_end_date).format(
                                              "MMM D, YYYY h:mm A"
                                            )}
                                            {")"} --
                                          </>
                                        )}
                                      </Typography>
                                    )}
                                </Grid>
                              </Grid>
                            }
                          >
                            <div
                              style={{
                                marginBottom: "6px",
                                borderRadius: "4px",
                                padding: "4px 6px",
                                backgroundColor: eventInfo.backgroundColor,
                                color: eventInfo.textColor,
                                display: "flex",
                                alignItems: "center",
                                overflow: "hidden",
                                cursor: isPastDate ? "none" : "pointer",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  marginLeft: 6,
                                  overflow: "hidden",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {(meeting_time || displayTitle) && (
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: 600,
                                      lineHeight: 1.2,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {meeting_time
                                      ? `${formatTime(
                                          meeting_time
                                        )} - ${displayTitle}`
                                      : displayTitle}
                                  </span>
                                )}
                              </div>

                              {!isPastDate && (
                                <div
                                  style={{
                                    flexShrink: 0,
                                    width: 20,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <CiEdit
                                    style={{ fontSize: 14, opacity: 0.9 }}
                                  />
                                </div>
                              )}
                            </div>
                          </Tooltip>
                        );
                      }}
                      dateClick={(info: DateClickArg) => {
                        const clickedDate = dayjs(info.dateStr);
                        // handleOpenDrawerPopUp(clickedDate);
                      }}
                      eventClick={(info: EventClickArg) => {
                        const event = info.event;
                        const clickedDateOnclick = dayjs(event.start);
                        const today = dayjs();

                        if (clickedDateOnclick.isBefore(today, "day")) {
                          return;
                        }
                        const row = info.event.extendedProps.row;
                        handleOpenDialogEditRequest(clickedDateOnclick, row);
                      }}
                      datesSet={(dateInfo) => {
                        const start = dayjs(dateInfo.start).format(
                          "YYYY-MM-DD"
                        );
                        const end = dayjs(dateInfo.end).format("YYYY-MM-DD");

                        console.log(
                          "Month changed, fetching data from",
                          start,
                          "to",
                          end
                        );
                        setStartDate(dayjs(start));
                        setEndDate(dayjs(end));
                      }}
                      dayCellDidMount={(arg) => {
                        arg.el.style.cursor = "pointer";

                        const cellDate = dayjs(arg.date).format("YYYY-MM-DD");
                      }}
                      dayCellContent={(arg) => {
                        const cellDate = dayjs(arg.date);
                        const formattedDate = cellDate.format("YYYY-MM-DD");
                        const today = dayjs().startOf("day");
                        const isPastDate = cellDate.isBefore(today, "day");
                        const activeId = getScheduleIdByDate(formattedDate);

                        const ActionCard = ({
                          label,
                          icon,
                          bg,
                          color,
                          onClick,
                        }: {
                          label: string;
                          icon: React.ReactNode;
                          bg: string;
                          color: string;
                          onClick: () => void;
                        }) => (
                          <Tooltip
                            placement="bottom-end"
                            title={label}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor:
                                    theme.palette.cardAdd.bgColor,
                                  color: theme.palette.heading.headingColor,
                                  borderRadius: setCardBRadius,
                                  padding: 1.5,
                                  border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                  fontSize: 13,
                                },
                              },
                              arrow: {
                                sx: {
                                  color: theme.palette.cardAdd.borderColor,
                                },
                              },
                            }}
                            arrow
                          >
                            <span>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!isPastDate) onClick();
                                }}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  background: bg,
                                  color,
                                  border: "none",
                                  padding: "4px 10px",
                                  borderRadius: "4px",
                                  transition: "all 0.2s ease",
                                  // minHeight: "20px",
                                }}
                              >
                                {icon}
                                {/* <span>{label}</span> */}
                              </div>
                            </span>
                          </Tooltip>
                        );

                        return (
                          <div style={{ width: "100%", padding: "4px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              {/* <ActionCard
                                label="Excel"
                                icon={<AiOutlineFileExcel size={14} />}
                                bg="#e8f5e9"
                                color="#2e7d32"
                                onClick={() => {
                                  setPdfDate(cellDate);
                                  handleExportByDate(cellDate, "excel");
                                }}
                              />

                              <ActionCard
                                label="PDF"
                                icon={<FaRegFilePdf size={14} />}
                                bg="#fdecea"
                                color="#c62828"
                                onClick={() => {
                                  setPdfDate(cellDate);
                                  handleExportByDate(cellDate, "pdf");
                                }}
                              /> */}

                              {!isPastDate && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenDialogRequest(cellDate);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: "#1976d2",
                                    background: "#dbe8f4",
                                    border: "none",
                                    padding: "4px 10px",
                                    borderRadius: "4px",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  + Add
                                </button>
                              )}

                              {/* Date */}
                              <div
                                style={{
                                  fontWeight: 700,
                                  fontSize: "13px",
                                  marginLeft: "auto",
                                }}
                              >
                                {cellDate.date()}
                              </div>
                            </div>
                          </div>
                        );
                      }}
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
        {/* {openDrawerPopUP && selectedDateDrawerPopUP && (
          <DrawerPopUp
            openModel={openDrawerPopUP}
            handleCloseDialogPopUp={handleCloseDrawerPopUp}
            paymentMonthYearDate={selectedDateDrawerPopUP}
          />
        )} */}

        {openDialogRequest && selectedDateRequestPopUP && (
          <RequestPopUp
            openModel={openDialogRequest}
            handleCloseDialog={handleCloseDialogRequest}
            scheduleDate={selectedDateRequestPopUP.format("YYYY-MM-DD")}
            staffId={String(staffId)}
            staffNameFull={String(staffNameFull)}
          />
        )}

        {openDialogEditRequest &&
          selectedDateEditRequestPopUP &&
          selectedCoursing && (
            <RequestEditPopUp
              openModel={openDialogEditRequest}
              handleCloseDialog={handleCloseDialoEditRequest}
              scheduleDate={selectedDateEditRequestPopUP.format("YYYY-MM-DD")}
              requestData={selectedCoursing}
            />
          )}
      </Grid>
    </div>
  );
};

export default Index;
